/* LGND Coming Soon — quick-view modal (image carousel + description),
   then NOTIFY ME → email form. */
(function () {
  const modal = document.getElementById('lgndCsModal');
  const quick = document.getElementById('lgndCsQuick');
  if (!modal || !quick) return;

  // The section uses a scroll-reveal that leaves a transform on the <section>
  // (an identity matrix). A transformed ancestor becomes the containing block
  // for position:fixed, so the modals' inset:0 resolved to the tall section
  // instead of the viewport — modal rendered off-screen while body scroll was
  // locked = "frozen screen". Portal the modals to <body> to fix it.
  [modal, quick].forEach(el => {
    if (el.parentElement !== document.body) document.body.appendChild(el);
  });

  // ----- Catalog from Liquid -----
  let catalog = [];
  try {
    catalog = JSON.parse(document.getElementById('lgndCsCatalog').textContent);
  } catch (e) {
    console.error('CS catalog parse', e);
  }
  const byHandle = Object.fromEntries(catalog.map(p => [p.handle, p]));

  // ----- Notify Me modal refs -----
  const form = document.getElementById('lgndCsForm');
  const closeBtns = document.querySelectorAll('[data-close]');
  const successEl = document.getElementById('lgndCsSuccess');
  const successName = document.getElementById('lgndCsSuccessName');
  const titleEl = document.getElementById('lgndCsTitle');
  const vendorEl = document.getElementById('lgndCsModalVendor');
  const imgEl = document.getElementById('lgndCsModalImg');
  const dropEl = document.getElementById('lgndCsModalDrop');
  const tagsEl = document.getElementById('lgndCsTags');
  const noteEl = document.getElementById('lgndCsNote');
  const smsCheck = document.getElementById('lgndCsSms');
  const phoneEl = document.getElementById('lgndCsPhone');

  // ----- Quick view refs -----
  const qVendor = document.getElementById('lgndCsQuickVendor');
  const qTitle = document.getElementById('lgndCsQuickTitle');
  const qPrice = document.getElementById('lgndCsQuickPrice');
  const qDrop = document.getElementById('lgndCsQuickDrop');
  const qDesc = document.getElementById('lgndCsQuickDesc');
  const qNotifyBtn = document.getElementById('lgndCsNotifyFromQuick');
  const qMain = document.getElementById('lgndCsMainImg');
  const qThumbs = document.getElementById('lgndCsThumbs');
  const qPrev = document.getElementById('lgndCsPrev');
  const qNext = document.getElementById('lgndCsNext');
  const qCounter = document.getElementById('lgndCsCounter');

  let currentProduct = null;
  let currentImgIdx = 0;

  function openModal(el) {
    el.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(() => el.classList.add('is-open'), 10);
  }
  function closeModal(el) {
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => { el.hidden = true; }, 200);
  }

  /* ----------------- Quick-view ----------------- */

  // In-memory cache of lazy-fetched product details (description + full image set)
  const detailsCache = {};

  function paintQuick(p) {
    qVendor.textContent = p.vendor || '';
    qTitle.textContent = (p.title || '').replace(/^[^-]+ -\s*/, '');
    qPrice.textContent = p.price || '';
    qDrop.textContent = p.drop_pretty ? `Drops ${p.drop_pretty}` : 'Drop date TBA';
    qDesc.innerHTML = p.description_html || '<p>Loading details…</p>';

    const images = (p.images || (p.image ? [p.image] : [])).filter(Boolean);
    qMain.src = images[0] || '';
    qMain.alt = p.title || '';
    qCounter.textContent = images.length ? `1 / ${images.length}` : '0 / 0';

    qThumbs.innerHTML = images.map((src, i) => `
      <button type="button" class="lgnd-cs__quick-thumb${i === 0 ? ' is-active' : ''}" data-idx="${i}" aria-label="View image ${i + 1}">
        <img src="${src}" alt="" loading="lazy" decoding="async">
      </button>
    `).join('');

    qThumbs.querySelectorAll('.lgnd-cs__quick-thumb').forEach(t => {
      t.addEventListener('click', () => setImage(Number(t.dataset.idx)));
    });

    const showArrows = images.length > 1;
    qPrev.style.display = showArrows ? 'flex' : 'none';
    qNext.style.display = showArrows ? 'flex' : 'none';
  }

  function renderQuick(p) {
    currentProduct = { ...p };  // mutable copy we can enrich
    currentImgIdx = 0;
    paintQuick(currentProduct);  // immediate paint with slim data (1 image, no desc)

    // Async-enrich with full description + all images via /products/{handle}.js
    if (detailsCache[p.handle]) {
      enrich(detailsCache[p.handle]);
    } else {
      fetch(`/products/${p.handle}.js`, { headers: { 'Accept': 'application/json' } })
        .then(r => r.ok ? r.json() : null)
        .then(data => {
          if (!data) return;
          const enriched = {
            description_html: data.description || '',
            images: (data.images || []).map(u => u.startsWith('//') ? `https:${u}` : u)
          };
          detailsCache[p.handle] = enriched;
          enrich(enriched);
        })
        .catch(() => {});
    }
  }

  function enrich(data) {
    if (!currentProduct) return;
    if (data.description_html) {
      currentProduct.description_html = data.description_html;
      qDesc.innerHTML = data.description_html;
    }
    if (data.images && data.images.length > 1) {
      currentProduct.images = data.images;
      // Repaint gallery only (preserves currentImgIdx)
      const images = data.images;
      qCounter.textContent = `${currentImgIdx + 1} / ${images.length}`;
      qThumbs.innerHTML = images.map((src, i) => `
        <button type="button" class="lgnd-cs__quick-thumb${i === currentImgIdx ? ' is-active' : ''}" data-idx="${i}" aria-label="View image ${i + 1}">
          <img src="${src}" alt="" loading="lazy" decoding="async">
        </button>
      `).join('');
      qThumbs.querySelectorAll('.lgnd-cs__quick-thumb').forEach(t => {
        t.addEventListener('click', () => setImage(Number(t.dataset.idx)));
      });
      qPrev.style.display = 'flex';
      qNext.style.display = 'flex';
    }
  }

  function setImage(idx) {
    if (!currentProduct) return;
    const images = currentProduct.images || [];
    if (!images.length) return;
    currentImgIdx = (idx + images.length) % images.length;
    qMain.src = images[currentImgIdx];
    qCounter.textContent = `${currentImgIdx + 1} / ${images.length}`;
    qThumbs.querySelectorAll('.lgnd-cs__quick-thumb').forEach((t, i) => {
      t.classList.toggle('is-active', i === currentImgIdx);
    });
  }

  qPrev.addEventListener('click', () => setImage(currentImgIdx - 1));
  qNext.addEventListener('click', () => setImage(currentImgIdx + 1));

  // Keyboard navigation in quick view
  document.addEventListener('keydown', e => {
    if (!quick.hidden) {
      if (e.key === 'ArrowLeft') setImage(currentImgIdx - 1);
      if (e.key === 'ArrowRight') setImage(currentImgIdx + 1);
      if (e.key === 'Escape') closeModal(quick);
    } else if (!modal.hidden) {
      if (e.key === 'Escape') closeModal(modal);
    }
  });

  // Card click → quick view
  document.addEventListener('click', e => {
    const btn = e.target.closest('.lgnd-cs__quickview-btn');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.productHandle;
    const product = byHandle[handle];
    if (!product) {
      console.warn('No product for handle', handle);
      return;
    }
    renderQuick(product);
    openModal(quick);
  });

  // Notify Me button from inside quick view → opens email modal
  qNotifyBtn.addEventListener('click', () => {
    if (!currentProduct) return;
    const p = currentProduct;
    const cleanTitle = (p.title || '').replace(/^[^-]+ -\s*/, '');
    titleEl.textContent = cleanTitle;
    vendorEl.textContent = p.vendor || '';
    imgEl.src = (p.images && p.images[0]) || '';
    imgEl.alt = cleanTitle;
    dropEl.textContent = p.drop_pretty ? `Drops ${p.drop_pretty}` : 'Drop date TBA';
    tagsEl.value = `notify-drop,notify-${p.handle},newsletter`;
    noteEl.value = `Notify me when ${p.title} (${p.handle}) drops.`;
    successName.textContent = cleanTitle || 'this drop';

    closeModal(quick);
    setTimeout(() => {
      form.hidden = false;
      successEl.hidden = true;
      openModal(modal);
    }, 220);
  });

  /* ----------------- Notify Me email modal (existing) ----------------- */

  closeBtns.forEach(b => b.addEventListener('click', () => {
    const parent = b.closest('.lgnd-cs__modal');
    if (parent) closeModal(parent);
  }));

  smsCheck.addEventListener('change', () => {
    phoneEl.hidden = !smsCheck.checked;
    phoneEl.required = smsCheck.checked;
  });

  /* ---------------- Klaviyo configuration ----------------
     Company ID: pulled from your storefront Klaviyo embed.
     LIST_ID: REQUIRED for subscriptions. Get it from Klaviyo:
       Audience → Lists & Segments → (create "Coming Soon Notifications")
       → click the list → URL ends in /list/<LIST_ID>
     Paste the ID below, then save. Without it, subscribe will fail.
  -------------------------------------------------------- */
  const KLAVIYO_COMPANY_ID = 'QSFxmY';
  const KLAVIYO_LIST_ID = 'WyFmVR'; // Coming Soon Notifications list

  function formatPhoneE164(raw) {
    if (!raw) return null;
    const digits = raw.replace(/\D/g, '');
    if (!digits) return null;
    // US default: 10 digits → +1XXXXXXXXXX, 11 digits starting with 1 → +1...
    if (digits.length === 10) return `+1${digits}`;
    if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
    // Otherwise assume already E.164-formatted
    return raw.startsWith('+') ? raw : `+${digits}`;
  }

  async function subscribeToKlaviyo({ email, phone, properties }) {
    if (!KLAVIYO_COMPANY_ID || KLAVIYO_COMPANY_ID === 'REPLACE_WITH_COMPANY_ID') {
      throw new Error('Klaviyo company ID not configured');
    }
    if (!KLAVIYO_LIST_ID || KLAVIYO_LIST_ID === 'REPLACE_WITH_LIST_ID') {
      throw new Error('Klaviyo list ID not configured — see lgnd-coming-soon.js header');
    }

    const subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    const profileAttrs = { email, properties };
    if (phone) {
      profileAttrs.phone_number = phone;
      subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }
    profileAttrs.subscriptions = subscriptions;

    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'LGND Coming Soon',
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttrs
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
        }
      }
    };

    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(KLAVIYO_COMPANY_ID)}`;
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(body)
    });
    if (!res.ok && res.status !== 202) {
      let detail = '';
      try { detail = JSON.stringify(await res.json()); } catch (_) {}
      throw new Error(`Klaviyo ${res.status}: ${detail || 'subscription rejected'}`);
    }
    return true;
  }

  form.addEventListener('submit', async e => {
    e.preventDefault();
    const submitBtn = form.querySelector('button[type="submit"]');
    const original = submitBtn.textContent;
    submitBtn.textContent = 'SUBMITTING…';
    submitBtn.disabled = true;

    const fd = new FormData(form);
    const email = (fd.get('contact[email]') || '').toString().trim();
    const phoneRaw = (fd.get('contact[phone]') || '').toString().trim();
    const phone = smsCheck.checked ? formatPhoneE164(phoneRaw) : null;

    // Pull product context from the modal (set when NOTIFY ME was clicked)
    const p = currentProduct || {};
    const properties = {
      notify_drop_handle: p.handle || '',
      notify_drop_title: (p.title || '').replace(/^[^-]+ -\s*/, ''),
      notify_drop_vendor: p.vendor || '',
      notify_drop_date: p.drop_iso || '',
      notify_drop_image: (p.images && p.images[0]) || p.image || '',
      source: 'coming_soon_modal'
    };

    try {
      await subscribeToKlaviyo({ email, phone, properties });
      form.hidden = true;
      successEl.hidden = false;
      form.reset();
      phoneEl.hidden = true;
    } catch (err) {
      console.error('Klaviyo subscribe failed:', err);
      submitBtn.textContent = 'TRY AGAIN';
      submitBtn.disabled = false;
    } finally {
      setTimeout(() => {
        submitBtn.textContent = original;
        submitBtn.disabled = false;
      }, 5000);
    }
  });
})();

/* LGND Coming Soon — category filter + load-more pagination */
(function () {
  const filterBar = document.getElementById('lgndCsFilters');
  const grid = document.getElementById('lgndCsGrid');
  const loadMoreBtn = document.getElementById('lgndCsLoadMore');
  const loadMoreWrap = loadMoreBtn ? loadMoreBtn.parentElement : null;
  const shownCountEl = document.getElementById('lgndCsShownCount');
  const filteredCountEl = document.getElementById('lgndCsFilteredCount');
  const filteredLabelEl = document.getElementById('lgndCsFilteredLabel');
  if (!filterBar || !grid) return;

  const PAGE_SIZE = 24;
  let currentFilter = 'all';
  let visibleCount = PAGE_SIZE;

  const allCards = Array.from(grid.querySelectorAll('.lgnd-cs__card-wrap'));

  function applyFilter() {
    const filteredCards = currentFilter === 'all'
      ? allCards
      : allCards.filter(c => c.dataset.cat === currentFilter);

    // First hide everything
    allCards.forEach(c => c.style.display = 'none');

    // Show up to visibleCount filtered cards
    filteredCards.slice(0, visibleCount).forEach(c => c.style.display = '');

    // Update meta
    const shown = Math.min(visibleCount, filteredCards.length);
    if (shownCountEl) shownCountEl.textContent = shown;
    if (filteredCountEl) filteredCountEl.textContent = filteredCards.length;
    if (filteredLabelEl) {
      const labels = {
        all: 'drops',
        fragrance: 'fragrances',
        jeans: 'jeans',
        shorts: 'shorts',
        tops: 'tops',
        sneakers: 'sneakers',
        other: 'items'
      };
      filteredLabelEl.textContent = labels[currentFilter] || 'items';
    }

    // Toggle load-more visibility
    if (loadMoreWrap) {
      loadMoreWrap.style.display = filteredCards.length > visibleCount ? '' : 'none';
    }
  }

  // Wire filter buttons
  filterBar.addEventListener('click', e => {
    const btn = e.target.closest('.lgnd-cs__filter');
    if (!btn) return;
    filterBar.querySelectorAll('.lgnd-cs__filter').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    currentFilter = btn.dataset.cat || 'all';
    visibleCount = PAGE_SIZE;  // reset pagination on filter change
    applyFilter();
    // Smooth-scroll grid into view if filter was hit lower on page
    grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Wire load-more
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
      visibleCount += PAGE_SIZE;
      applyFilter();
    });
  }

  // Initial render
  applyFilter();
})();
